import ApartmentIcon from '@mui/icons-material/Apartment';
import AssessmentIcon from '@mui/icons-material/Assessment';
import EnergySavingsLeafIcon from '@mui/icons-material/EnergySavingsLeaf';
import SavingsIcon from '@mui/icons-material/Savings';

export const homepageItems = [
    {
        'id': '1',
        'title': 'Building characteristics & energy usage',
        'description': 'Provide your building’s and energy systems’ characteristics through the tool’s questionnaire. Input data about your building envelope, heating/cooling systems, lighting, and electrical appliances.',
        'icon': <ApartmentIcon style={{ color: 'white', fontSize: '80px' }} />,
        'image': 'https://images.unsplash.com/photo-1728999018256-5a6ee5346d35?q=80&w=1740&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D', // Modern building
        'link': ''
    },
    {
        'id': '2',
        'title': 'Initial assessment',
        'description': 'Let the tool calculate your current CO2 emissions, energy costs, and energy consumption on an annual basis. Get useful insights through helpful charts and graphs of the results per energy system.',
        'icon': <AssessmentIcon style={{ color: 'white', fontSize: '80px' }} />,
        'image': 'https://plus.unsplash.com/premium_photo-1685086785641-1c4dbf5853b2?q=80&w=1932&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D', // Data analysis & charts
        'link': ''
    },
    {
        'id': '3',
        'title': 'Decarbonization actions',
        'description': 'Acquire a set of CO2 emissions minimization actions tailored to your building based on your available budget and preferences.',
        'icon': <EnergySavingsLeafIcon style={{ color: 'white', fontSize: '80px' }} />,
        'image': 'https://plus.unsplash.com/premium_photo-1716259490126-8272a55f4572?q=80&w=1740&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D', // Green energy concept
        'link': ''
    },
    {
        'id': '4',
        'title': 'Savings',
        'description': 'Compare the savings generated after the implementation of the tool’s recommended actions and evaluate the results.',
        'icon': <SavingsIcon style={{ color: 'white', fontSize: '80px' }} />,
        'image': 'https://plus.unsplash.com/premium_photo-1716078757653-64b1f3db17c8?q=80&w=1740&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D', // Cost savings
        'link': ''
    },
];
